
import { Component, OnInit } from '@angular/core';
import {  ActivatedRoute, Router } from '@angular/router';
import { pageTypeEnum } from 'src/app/models/enums';
import { menu } from 'src/app/models/menu';
import { page } from 'src/app/models/page';
import { rootModel } from 'src/app/models/rootModel';
import { DataService } from 'src/app/Services/data.service';
import { TranslateService } from 'src/app/Services/translate.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {

  rootModel:rootModel = new rootModel();
  menus:menu[]=[]; 
  sayi:number;
  page:page= new page();
  
  epageTypeEnum = pageTypeEnum;
  constructor(
    public translateService:TranslateService,
     private dataServices:DataService,
     private router:Router,
     private route:ActivatedRoute,

     )     
      { 
        this.sayi = 10;
      }

      ngOnInit(): void {    
                   
        this.route.paramMap.subscribe(params=>{
    
          if(params.get("language"))
          this.rootModel.language  = params.get("language");  
          else
           this.rootModel.language='tr';
    
           this.getHomePage();
        })

      }
      
      
      getHomePage()
      {
        this.dataServices.getHomePage(this.rootModel).subscribe(p=>{

         this.page = p;

        })
      }



}
